import React, { useState } from 'react';
import { Link, useLocation, useNavigate } from 'react-router-dom';
import { useAuth } from '../App';
import logoImg from '../logo.png';

export default function Navbar() {
  const { user, logout } = useAuth();
  const location = useLocation();
  const navigate = useNavigate();
  const [mobileOpen, setMobileOpen] = useState(false);

  const isActive = (path) => location.pathname === path;

  const handleLogout = () => {
    logout();
    navigate('/');
    setMobileOpen(false);
  };

  const navLinks = [
    { to: '/', label: 'Home' },
    { to: '/analyze', label: 'Analyze' },
    { to: '/pricing', label: 'Pricing' },
    { to: '/dashboard', label: 'Dashboard' },
    ...(user ? [{ to: '/settings', label: 'Settings' }] : []),
  ];

  return (
    <nav style={{
      position: 'fixed',
      top: 0,
      left: 0,
      right: 0,
      zIndex: 1000,
      background: 'rgba(255, 255, 255, 0.95)',
      backdropFilter: 'blur(12px)',
      borderBottom: '1px solid var(--border)',
      height: '80px'
    }}>
      <div className="container" style={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between', height: '100%' }}>

        {/* Logo */}
        <Link to="/" style={{ display: 'flex', alignItems: 'center', gap: 0, textDecoration: 'none', marginLeft: 28 }}>
          <img
            src={logoImg}
            alt="ProPARV logo"
            style={{
              width: 80, height: 80,
              objectFit: 'contain',
              flexShrink: 0,
              marginTop: -4
            }}
          />
          <span style={{ fontSize: '1.25rem', fontWeight: 800, color: 'var(--text-primary)', letterSpacing: '-0.02em', marginLeft: -8 }}>
            PROP<span style={{ color: 'var(--primary-light)' }}>ARV</span>
          </span>
        </Link>

        {/* Desktop Nav */}
        <div className="hide-mobile" style={{ display: 'flex', alignItems: 'center', gap: 4 }}>
          {navLinks.map(link => (
            <Link
              key={link.to}
              to={link.to}
              style={{
                padding: '8px 16px',
                borderRadius: 8,
                fontSize: '0.9rem',
                fontWeight: 500,
                color: isActive(link.to) ? 'var(--text-primary)' : 'var(--text-secondary)',
                background: isActive(link.to) ? 'rgba(37,99,235,0.15)' : 'transparent',
                textDecoration: 'none',
                transition: 'all 0.2s ease',
                borderBottom: isActive(link.to) ? '2px solid var(--primary)' : '2px solid transparent'
              }}
              onMouseEnter={e => { if (!isActive(link.to)) e.target.style.color = 'var(--text-primary)'; }}
              onMouseLeave={e => { if (!isActive(link.to)) e.target.style.color = 'var(--text-secondary)'; }}
            >
              {link.label}
            </Link>
          ))}
        </div>

        {/* Auth Buttons - Desktop */}
        <div className="hide-mobile" style={{ display: 'flex', alignItems: 'center', gap: 10 }}>
          {user ? (
            <>
              <span style={{ fontSize: '0.85rem', color: 'var(--text-secondary)' }}>
                {user.name || user.email}
              </span>
              <button onClick={handleLogout} className="btn btn-ghost btn-sm">
                Logout
              </button>
            </>
          ) : (
            <>
              <Link to="/login" className="btn btn-ghost btn-sm">Login</Link>
              <Link to="/register" className="btn btn-primary btn-sm">Get Started</Link>
            </>
          )}
        </div>

        {/* Mobile Hamburger */}
        <button
          className="hide-desktop"
          onClick={() => setMobileOpen(!mobileOpen)}
          style={{
            background: 'none', border: 'none', color: 'var(--text-primary)',
            cursor: 'pointer', padding: 8, fontSize: 24
          }}
          aria-label="Toggle menu"
        >
          {mobileOpen ? '✕' : '☰'}
        </button>
      </div>

      {/* Mobile Menu */}
      {mobileOpen && (
        <div style={{
          background: 'var(--bg-card)',
          borderBottom: '1px solid var(--border)',
          padding: '12px 20px 20px',
          display: 'flex',
          flexDirection: 'column',
          gap: 8
        }}>
          {navLinks.map(link => (
            <Link
              key={link.to}
              to={link.to}
              onClick={() => setMobileOpen(false)}
              style={{
                padding: '12px 16px',
                borderRadius: 8,
                fontSize: '0.95rem',
                fontWeight: 500,
                color: isActive(link.to) ? 'var(--text-primary)' : 'var(--text-secondary)',
                background: isActive(link.to) ? 'rgba(37,99,235,0.15)' : 'transparent',
                textDecoration: 'none'
              }}
            >
              {link.label}
            </Link>
          ))}
          <div style={{ borderTop: '1px solid var(--border)', paddingTop: 12, marginTop: 4, display: 'flex', gap: 10 }}>
            {user ? (
              <button onClick={handleLogout} className="btn btn-ghost" style={{ width: '100%' }}>
                Logout ({user.email})
              </button>
            ) : (
              <>
                <Link to="/login" className="btn btn-ghost" style={{ flex: 1 }} onClick={() => setMobileOpen(false)}>Login</Link>
                <Link to="/register" className="btn btn-primary" style={{ flex: 1 }} onClick={() => setMobileOpen(false)}>Register</Link>
              </>
            )}
          </div>
        </div>
      )}
    </nav>
  );
}
